/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Show_PreferencesInputs */

const da_consent_show_preferences = /** @type {(inputs: Consent_Show_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indstillinger`)
};

/** @type {(inputs: Consent_Show_PreferencesInputs) => LocalizedString} */
const en_consent_show_preferences = da_consent_show_preferences;

/**

* @param {Consent_Show_PreferencesInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_show_preferences = /** @type {((inputs?: Consent_Show_PreferencesInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Show_PreferencesInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_show_preferences(inputs)
	return /** @type {LocalizedString} */ ("Indstillinger")
});